import Text from '~components/Text';
import { ICompanyCultureReviewChart } from '~hooks/query/company/useCompanyCultureReview';

import * as S from './style';

interface Props {
  chartData: ICompanyCultureReviewChart;
}
function BarChart({ chartData }: Props) {
  const isEmpty = chartData.leftData.count + chartData.rightData.count === 0;

  return (
    <S.ChartWrapper isEmpty={isEmpty} role='img' aria-label='Horizontal Bar Chart'>
      {isEmpty && <S.EmptyMessage>등록된 리뷰가 없습니다.</S.EmptyMessage>}
      <S.Bar role='presentation' leftWidth={chartData.leftData.rate} />
      <Text typography='midium150_C1'>
        {chartData.leftData.rate}% ({chartData.leftData.count}명)
      </Text>
      <Text typography='midium150_C1'>
        {chartData.rightData.rate}% ({chartData.rightData.count}명)
      </Text>
    </S.ChartWrapper>
  );
}

export default BarChart;
